import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-action-panel',
  templateUrl: './action-panel.component.html',
  styleUrls: ['./action-panel.component.scss']
})
export class ActionPanelComponent {

  @Input() data:any
  @Output() actionStatus:EventEmitter<object> = new EventEmitter()
  @Output() isAcknowledge:EventEmitter<boolean> = new EventEmitter()


  constructor(
    public sharedservice:SharedService,
    public alertvarservice:AlertsvarService,
    private alertservice:AlertsService
  ){

  }
  
  actionPanelMetadata = {
    "title":"ANALYST ACTION PANEL",
    "status_info":"Current Status",
    "action_headers":{"action":"NEXT STATUS ACTION","priority":"UPDATE PRIORITY (OPTIONAL)","reassign":"REASSIGN ANALYST","comment":"COMMENT (OPTIONAL)","terminal1":"This alert is in a terminal state","terminal2":"Status actions are disabled."},
    "action_buttons":{"cancel":"Cancel","save":"Save Action","acknowledge":"Acknowledge"},
    "action_placeholders":{"action":"Select Action","comment":"Select Comment (Optional)","priority":"Select Priority (Optional)","reassign":"Select Analyst"}
  }

  current_status = 0;
  current_status_obj:any = {}
  isAcknowledgeClick:boolean= false;

  action_panel = new FormGroup({
    action: new FormControl('',[Validators.required]),
    priority: new FormControl(),
    reassign: new FormControl(),
    reason: new FormControl()
  })

  current_action:any = {}

  

  ngOnInit(){
// console.log("===",this.data)

    if(this.data.alert_info.hasOwnProperty("dedup")){
      this.data.alert_info.dedup.forEach((element:any) => {
        this.current_status = element.status   
      });
    }else{
      this.data.alert_info.status.forEach(val=>{
        this.current_status = val
      })
    }
    
    this.getCurrentAction()
    this.action.valueChanges.subscribe((actionval)=>{
      this.resetActionPanel()
      this.getActions(actionval)
    })
  }

  resetActionPanel(){
    this.priority.reset()
    this.reassign.reset()
    this.reason.reset()
  }

  validateReassign(){
    if(!this.isEmptyObject(this.current_action)  && this.current_action.reassign){
      this.reassign.addValidators(Validators.required)
    } else {
      this.reassign.removeValidators(Validators.required)
    }
    this.reassign.updateValueAndValidity();
  }
  cancelAction(){
    this.actionStatus.emit({"event":"cancel"});
  }

  saveAction(){
// console.log("action value==",this.action_panel.value)
    if(this.current_status == 0){

    }else{
       if(this.action_panel.valid){
      let updateObj = {...this.data.alert_info,...this.action_panel.value}
      this.actionStatus.emit({"event":"save","request":updateObj})
    }
    }
   
  }

  get action() {
    return this.action_panel.get('action') as FormControl
  }

  get priority() {
    return this.action_panel.get('priority') as FormControl
  }

  get reassign(){
    return this.action_panel.get('reassign') as FormControl
  }

  get reason (){
    return this.action_panel.get('reason') as FormControl
  }

  isEmptyObject(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }


  getActions(current_status:string){
    this.current_action = this.sharedservice.actions.actions[current_status]
    this.validateReassign()
// console.log(this.current_action)
  }

  getReasons(action){
    return [{"disp":"Select Comment (Optional)","value":""},...this.sharedservice.getreason(action)]
  }

  

  getCurrentAction(){
    this.action.reset()
    this.current_status_obj = this.sharedservice.getCurrentStatusDisp(this.current_status)
    if(this.current_status == 0){
      this.isAcknowledgeClick = true;
      this.action.setValue(1)
    } else {
      this.isAcknowledgeClick = false;
    }
    
  }

  find_terminal_state(){
    return this.sharedservice.terminal_status.includes(this.current_status) 
  }

  acknowledgeALert(){
    let updateObj = {...this.data.alert_info,...this.action_panel.value}
// console.log(updateObj,"====")
    let updateaction:Promise<any> = new Promise((resolve,reject)=>{});
    if(updateObj.hasOwnProperty("selectedAlert")){
      updateaction = this.alertservice.actionPost.postrequest(updateObj)
    } else {
      updateaction = this.alertservice.updateAlertActionPost.postrequest(updateObj)
    }
    updateaction
    .then((val:any)=>{
// console.log(val)
      if(val.status) {
        this.alertvarservice.createtoastmsg({
          "type": "success",
          "text": "The action has been successfully updated"
        })
        this.isAcknowledge.emit(true)
        this.current_status = this.action.value
        this.getCurrentAction()

      } else {
        this.alertvarservice.createtoastmsg({
          "type": "error",
          "text": "Failed to update action"
        })
      }
    })
    .catch((err)=>{
// console.log(err,"=========")
    })
  }

}
